const Resources = {

    table_headers: [
        {
            text:   'Walking#',
            value:  'walking_number',
            type:   'link',
        },
        { 
            text:   'Description',
            value:  'sort_desc',
            type:   'link',
        },
        { 
            text:   'Fixture/Beds',
            value:  'fixture_number',
        },
        { 
            text:   'Minutes',
            value:  'daily_tasks_minutes'
        },
        { 
            text:   'Sq.Feet',
            value:  'sq_ft'
        },
        {   
            text:   'DailyTask(s)',
            value:  'daily_tasks',
            type:   'tasks'
        },
        {   
            text:   'PolicingTask(s)',
            value:  'policing_tasks',
            type:   'tasks',
            class:  'header-blu',
        },
        {   
            text:   'ProjectTask(s)',
            value:  'project_tasks',
            type:   'tasks',
            class:  'header-orange',
        },
    ],

    breadcrumb:[
        {
            name:   'Home',
            href:   '/',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Buildings',
            href:   '/buildings',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Rooms',
            href:   '/building-rooms',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Rooms - Mass edit rooms',
            href:   '/building-rooms-mass-edit',
            arrow:  "",
        },
    ],

    boolean_options:[
        {
            id:     true,
            name:   'Yes',
        },
        {
            id:     false,
            name:   'No',
        },
    ],

    excl_options:[
        {
            id:     true,
            name:   'Yes',
        },
        {
            id:     false,
            name:   'No',
        },
    ],

   

    simbol_options:[
        {
            id:     1,
            name:   '=',
        },
        {
            id:     2,
            name:   '<',
        },
        {
            id:     3,
            name:   '>',
        },
    ],

    shift_criteria_options:[
        {
            id:     1,
            name:   'All selected shifts',
        },
        {
            id:     2,
            name:   'Any selected shifts',
        },
    ],

    helps: [
        {
            label: '¿How to mass edit Rooms?', 
            instruction: `https://scribehow.com/embed/How_to_Mass_Edit_Rooms__PcR_bQAQTgKM1MnxXEoTmw?as=scrollable`
        },
    ],

}

export default Resources